module.exports = require("skypager-registry");


//////////////////
// WEBPACK FOOTER
// external "skypager-registry"
// module id = 15
// module chunks = 0